module.exports = __webpack_public_path__ + "img/電気回路_3_6.cfd3b091.png";